import { useContext, useEffect } from 'react';
import { MiniCardGrafico } from './MiniCardGrafico';
import { useInternacionesIniciadoAutorizadoTotales } from '../hooks';
import { InternacionesTramitesContext } from '../context';
import dayjs from 'dayjs';
import { GraficoLine } from './GraficoLine';
import { Grid } from '@mui/material';

export const IniciadoAutorizadoAnualDemorasTotal = () => {
  const { anualList, anualDate } = useContext(InternacionesTramitesContext);
  const { dataDemora0_7Anual, dataDemora7_30Anual, dataDemora30MasAnual, getTramitesAnualDemoras } =
    useInternacionesIniciadoAutorizadoTotales({
      anualList,
      anualDate,
    });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getTramitesAnualDemoras();
    }
  }, [anualList, anualDate]);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora0_7Anual?.total || 0}
          title={
            <>
              <span>En proceso normal de autorización</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora0_7Anual?.labels || []}
            datasets={dataDemora0_7Anual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora7_30Anual?.total || 0}
          title={
            <>
              <span>Autorizaciones con demora de 7 a 30 días</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora7_30Anual?.labels || []}
            datasets={dataDemora7_30Anual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora30MasAnual?.total || 0}
          title={
            <>
              <span>Autorizaciones con demora de +30 días</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora30MasAnual?.labels || []}
            datasets={dataDemora30MasAnual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
    </>
  );
};
